const STORAGE_KEY = 'utm_params';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;
const EXPIRY_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export type UtmParams = Partial<Record<typeof UTM_KEYS[number], string>>;

type StoredUtm = { params: UtmParams; ts: number };

function readStored(): UtmParams {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const stored: StoredUtm = JSON.parse(raw);
    if (Date.now() - stored.ts > EXPIRY_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return {};
    }
    return stored.params;
  } catch {
    return {};
  }
}

export function captureUtm(): void {
  if (localStorage.getItem(STORAGE_KEY)) return;
  const params = new URLSearchParams(window.location.search);
  const utm: UtmParams = {};
  for (const key of UTM_KEYS) {
    const val = params.get(key);
    if (val) utm[key] = val;
  }
  if (Object.keys(utm).length) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ params: utm, ts: Date.now() }));
  }
}

export function getUtmParams(): UtmParams {
  return readStored();
}

export function getUtmSource(): string | null {
  return readStored().utm_source ?? null;
}

export function clearUtm(): void {
  localStorage.removeItem(STORAGE_KEY);
}
